import { FormInput } from 'src/components/molecules';
import { formatDateWithSlash } from 'src/components/pages/Cases/helpers/formatDate';
import { FormInputVariant, FormState } from 'src/types';
import {
  DetailsRowContainer,
  DetailsRowWrapper,
} from '../ReviewCaseTeamMemberModal.styles';

interface DetailsRowProps {
  name: string;
  site: string;
  role: string;
  country: string;
  status: string;
  invitedAt?: string;
}

export const DetailsRow = ({
  name,
  role,
  site,
  country,
  status,
  invitedAt = '0000-00-00T00:00:00.000Z',
}: DetailsRowProps) => {
  return (
    <>
      <DetailsRowWrapper>
        <DetailsRowContainer>
          <FormInput
            label="Name"
            value={name}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />

          <FormInput
            label="Role"
            value={role}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />

          <FormInput
            label="Site"
            value={site}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />
        </DetailsRowContainer>

        <DetailsRowContainer>
          <FormInput
            label="Country"
            value={country}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />

          <FormInput
            label="Status"
            value={status}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />

          <FormInput
            label="Invited to case"
            value={formatDateWithSlash(invitedAt)}
            variant={FormInputVariant.INPUT}
            onChange={() => {}}
            state={FormState.READONLY}
          />
        </DetailsRowContainer>
      </DetailsRowWrapper>
    </>
  );
};
